export default __webpack_public_path__ + "static/media/ecommerce.f2200264.jpg";